import React from 'react'
import { List } from 'antd'
import { useTranslation } from 'next-i18next'
import { Subscription } from 'src/core/models'
import { CustomTitle, CustomText, TextsListColumn } from 'src/components'

const UserSubscriptionMovileView: React.FC<{ subscription: Subscription }> = ({ subscription }) => {
  const { t } = useTranslation()

  const labels = [
    {
      label: t('Subscription.BASIC_PLAN'),
      items: [subscription.basicPlanLabel]
    },
    {
      label: t('Subscription.API_PRO'),
      items: subscription.proPlanLabels
    },
    {
      label: t('Subscription.PREMIUM_PLAN'),
      items: subscription.premiumPlanLabels
    }

  ]

  return <>
    <CustomTitle label={subscription.mainlabel} type={null} />
    <List dataSource={labels}
      renderItem={item => (
        <List.Item>
          <React.Fragment>
            <CustomText label={t(item.label)} strong />
            <TextsListColumn texts={item.items} />
          </React.Fragment>
        </List.Item>
      )}
    />
  </>
}

export default UserSubscriptionMovileView
